module.exports = __webpack_public_path__ + "img/file-excel.a670f66a.svg";